// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__AUzUp","footer":"ModalError_footer__MX-wD"};